import {useContext} from 'react'
import {Link} from 'react-router-dom'
import {ProfitabilityContext} from '../../context'

const CustomerTableHeader = () => {
  const {isFullView} = useContext(ProfitabilityContext)

  if (isFullView) return null

  return (
    <div className='d-flex flex-row justify-content-between mb-8'>
      <h2 className='text-dark fw-bolder mb-0'>Customer</h2>
      <div className='mt-2'>
        <Link
          to='/analytics/profitability/profitability-report?view=dashboard-customers'
          className='text-primary text-hover-dark text-decoration-underline fw-semibold'
        >
          View All
        </Link>
      </div>
    </div>
  )
}

export default CustomerTableHeader
